/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RevokeUserInviteResponseBase
 * auto generated base class for the model RevokeUserInviteResponseModel.
 */
export const RevokeUserInviteResponseModelBase = ModelBase
  .named('RevokeUserInviteResponse')
  .props({
    __typename: types.optional(types.literal("RevokeUserInviteResponse"), "RevokeUserInviteResponse"),
    success: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RevokeUserInviteResponseModelSelector extends QueryBuilder {
  get success() { return this.__attr(`success`) }
}
export function selectFromRevokeUserInviteResponse() {
  return new RevokeUserInviteResponseModelSelector()
}

export const revokeUserInviteResponseModelPrimitives = selectFromRevokeUserInviteResponse().success
